import { styled } from 'styled-components';

import { Container, InsidePageHeroContainer, theme, TitleBanner } from '@foradevelopment/fora-ui';

import { CompanyDetailsCard } from '../../CompanyDetailsCard/CompanyDetailsCard';
import { ResponsiveNavBar } from '../ResponsiveNavbar';

export const BigHeader = ({
  title,
  subTitle,
  link,
  hasSelectedEmployer,
}: {
  title: string;
  subTitle: string;
  link?: { name: string; to: string };
  hasSelectedEmployer: boolean;
}) => {
  return (
    <>
      <ResponsiveNavBar hasSelectedEmployer={hasSelectedEmployer} />
      <TitleBanner subtitle={subTitle} title={title} link={link} />
      <Container>
        <HeaderBottomPiece />
        <InsidePageHeroContainer>
          <CompanyDetailsCard />
        </InsidePageHeroContainer>
      </Container>
    </>
  );
};

const HeaderBottomPiece = styled.div`
  height: 60px;
  border-bottom: 4px solid ${theme.colors.darkBlue};
  background-color: ${theme.colors.foraBlue};
  box-sizing: border-box;
`;
